export const LOAD_NOTES = 'LOAD_NOTES'